import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'currencyFormat',
})
export class UICurrencyFormatPipe implements PipeTransform {
	transform(value: any, args?: any): any {
		if (value !== null && typeof value !== 'undefined') {
			return value.charAt(0) === '(' ? '-' + value.substring(1, value.length - 1) : value;
		} else {
			return value;
		}
	}
}
